<template>

  <div v-bind:class="{'preloader': !plain, 'preloader-plain': plain}">
    <div v-if="text" class="preloader-text text-center">{{ text }}</div>
    <v-progress-linear
      indeterminate
      :color="iconcolor"
    ></v-progress-linear>
  </div>

</template>

<script>
export default {
  name: 'Preloader',
  props: {
    text: { },
    iconcolor: { type: String, default: "primary" },
    plain: { type: Boolean, default: false },
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.preloader {
  width: 300px;
  margin: 100px auto;
  text-align: center;
  color: #26a65b;
}
.preloader-plain {
  max-width: 300px;
  margin: 10px auto;
  color: #26a65b;
}
.preloader-text {
  margin: 20px;
}
</style>
